import ERRORS from './error'
import { convertString, convertNumber, getDataType } from './_utils'
export const TEXT_HELPER = {
  CONCAT: {
    title: '合并文本',
    usage: 'CONCAT(文本1,文本2,...)',
    desc: '将两个或多个文本合并为一个整体',
    example: 'CONCAT("人生","得意","须尽欢") => 结果: "人生得意须尽欢"'
  },

  REPLACE: {
    title: '替换文本',
    usage: 'REPLACE(原文本,开始位置,字符数,[替换文本])',
    desc: '使用指定字符替换指定位置上的内容,开始位置:1代表从第一个字符开始,且第一个字符也要被替换,字符数:需要替换的字符数,字母、汉字、数字、空格都记为1个字符',
    example: 'REPLACE("1234风飘絮,身世浮沉雨打萍",1,4,"山河破碎") => 结果: "山河破碎风飘絮,身世浮沉雨打萍"'
  },

  MID: {
    title: '从中间提取',
    usage: 'MID(原文本,开始位置,字符数)',
    desc: '返回文本中从指定位置开始指定个数的字符;开始位置:1代表从第一个字符开始,且第一个字符也要被提取;字符数:需要提取的字符数,字母、汉字、数字、空格都记为1个字符',
    example: 'MID("相思相望不相亲,天为谁春",9,4) => 结果: "天为谁春"'
  },

  LEFT: {
    title: '从左提取',
    usage: 'LEFT(原文本,字符数)',
    desc: '从文本最左侧起提取指定个数的字符',
    example: 'LEFT("日日思君不见君,共饮长江水",7) => 结果: "日日思君不见君"'
  },

  RIGHT: {
    title: '从右提取',
    usage: 'RIGHT(原文本,字符数)',
    desc: '从文本最右侧起提取指定个数的字符',
    example: 'RIGHT("王孙游兮不归,春草生兮萋萋",6) => 结果: "春草生兮萋萋"'
  },

  TRIM: {
    title: '删除空格',
    usage: 'TRIM(文本)',
    desc: '删除文本首尾的空格',
    example: 'TRIM(" 一川烟草 满城风絮 梅子黄时雨  ") => 结果: "一川烟草 满城风絮 梅子黄时雨"'
  },

  CLEAN: {
    title: '删除所有空格',
    usage: 'CLEAN(文本)',
    desc: '删除文本中所有空格',
    example: 'CLEAN(" 逃 之夭  夭,灼灼其 华") => 结果: "逃之夭夭,灼灼其华"'
  },

  LOWER: {
    title: '转小写',
    usage: 'LOWER(文本)',
    desc: '将文本中的大写字母转换为小写字母',
    example: 'LOWER("HELLO WORLD") => 结果: "hello world"'
  },

  UPPER: {
    title: '转大些',
    usage: 'UPPER(文本)',
    desc: '将文本中的小写字母转换为大写字母',
    example: 'UPPER("Hello world") => 结果: "HELLO WORLD"'
  },

  FIND: {
    title: '查找单个文本',
    usage: 'FIND(原文本, 开始字符, 结束字符)',
    desc: '返回指定间隔符之间的文本内容(只返回从左到右查找到的第一个);开始字符：如果是空，表示从第一个字符开始返回;结束字符：如果是空，表示返回直至最后一个字符',
    example: 'FIND("1天23小时15分钟","","天") => 结果: 1'
  },

  FINDALL: {
    title: '查找多个文本',
    usage: 'FINDALL(原文本, 开始字符, 结束字符)',
    desc: '返回指定间隔符之间的文本内容，从左到右查找所有内容，并将结果打包成数组返回;开始字符：如果是空，将无法得到结果;结束字符：如果是空，将无法得到结果;',
    example: 'FINDALL("(X2022)2f8f0af(NZP001)","(",")") => 结果: X2022,NZP001'
  },

  SPLIT: {
    title: '分割文本',
    usage: 'SPLIT(原文本, 间隔符)',
    desc: '按照指定的间隔符分割文本，将分割结果打包成数组返回; 间隔符:如果为空，将分割每一个字符',
    example: 'SPLIT("1998-08-08","-") => 结果: 1998,08,08'
  },

  JOIN: {
    title: '合并文本',
    usage: 'JOIN(数组, 间隔符)',
    desc: '按照指定的间隔符把数组元素拼接成文本',
    example: 'JOIN(SPLIT("1998-08-08","-"), "/") => 结果: "1998/08/08"'
  },

  STRING: {
    title: '强制转为文本',
    usage: 'STRING(数值)',
    desc: '将数值等类型的值转为文本',
    example: 'STRING(-1)+STRING(5) => 结果："-15"'
  }
}

export const CONCAT = (...args) => {
  if (args.length < 2) ERRORS.ARG_LENGTH_ERROR('CONCAT', 2, args.length, false)
  return args.map(item => convertString(item)).join('')
}

export const REPLACE = (...args) => {
  if (args.length < 3) ERRORS.ARG_LENGTH_ERROR('REPLACE', 3, args.length, false)
  let [sourceText, pos, total, targetText = ''] = args
  sourceText = convertString(sourceText).split('')
  sourceText.splice(convertNumber(pos) - 1, convertNumber(total), targetText)
  return sourceText.join('')
}

export const MID = (...args) => {
  if (args.length < 3) ERRORS.ARG_LENGTH_ERROR('MID', 3, args.length)
  let [sourceText, start, total] = args
  return convertString(sourceText).slice(convertNumber(start) - 1, convertNumber(start) - 1 + convertNumber(total))
}

export const LEFT = (...args) => {
  if (args.length < 2) ERRORS.ARG_LENGTH_ERROR('LEFT', 2, args.length)
  let [sourceText, total] = args
  return convertString(sourceText).slice(0, convertNumber(total))
}

export const RIGHT = (...args) => {
  if (args.length < 2) ERRORS.ARG_LENGTH_ERROR('RIGHT', 2, args.length)
  let [sourceText, total] = args
  return convertString(sourceText).slice(0 - convertNumber(total))
}

export const TRIM = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('TRIM', 1, args.length)
  return convertString(args[0]).replace(/(^\s*)|(\s*$)/g, '')
}

export const CLEAN = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('CLEAN', 1, args.length)
  return convertString(args[0]).replace(/\s+/g, '')
}

export const LOWER = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('LOWER', 1, args.length)
  return convertString(args[0]).toLowerCase()
}

export const UPPER = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('UPPER', 1, args.length)
  return convertString(args[0]).toUpperCase()
}

export const FIND = (...args) => {
  if (args.length < 3) ERRORS.ARG_LENGTH_ERROR('FIND', 3, args.length)
  let [sourceText, start, end] = args
  sourceText = convertString(sourceText)
  start = start === '' ? 1 : sourceText.indexOf(start) + 2
  end = end === '' ? sourceText.length : sourceText.indexOf(end) == -1 ? 0 : sourceText.indexOf(end) - start + 1
  return MID(sourceText, start, end)
}

export const FINDALL = (...args) => {
  if (args.length < 3) ERRORS.ARG_LENGTH_ERROR('FINDALL', 3, args.length)
  let [text, startChar, endChar] = args
  startChar = convertString(startChar)
  endChar = convertString(endChar)
  if (!startChar || !endChar) return [];

  const results = [];
  let startIndex = 0;

  while (true) {
    const startPos = text.indexOf(startChar, startIndex)
    if (startPos === -1) break

    const endPos = text.indexOf(endChar, startPos + 1)
    if (endPos === -1) break

    results.push(text.substring(startPos + 1, endPos))

    startIndex = endPos + 1
  }

  return results
}

export const SPLIT = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('SPLIT', 1, args.length, false)
  let [sourceText, separator = ''] = args
  return convertString(sourceText).split(separator)
}

export const JOIN = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('JOIN', 1, args.length, false)
  let [sourceArr, spaceCharacter = ''] = args
  if (!Array.isArray(sourceArr)) ERRORS.DATA_TYPE_ERROR('JOIN', 1, '数组', getDataType(sourceArr, true))
  return sourceArr.join(spaceCharacter)
}

export const STRING = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('STRING', 1, args.length)
  return convertString(args[0])
}

